import React, { useEffect, useState } from "react";

const abs = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
const initials = (name = "") => name.replace(/^dr\.?\s*/i, "").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "Dr";

/** Doctor photo with graceful fallback (initials) when the URL is missing or fails to load. */
export function DoctorAvatar({ doctor, className = "w-12 h-12 rounded-xl", textClass = "text-lg", testId }) {
  const src = abs(doctor?.image_url || doctor?.profile_photo || "");
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);
  if (src && !broken) return <img src={src} alt={doctor?.name || "Doctor"} onError={() => setBroken(true)} loading="lazy" className={`${className} object-cover shrink-0`} data-testid={testId} />;
  return <div className={`${className} bg-[#0D3B2E] text-amber-300 flex items-center justify-center font-serif-luxury font-bold shrink-0 ${textClass}`} data-testid={testId} aria-label={doctor?.name}>{initials(doctor?.name)}</div>;
}

export default DoctorAvatar;
